import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Partners1 from "../assets/img/microsoft.png";
import Partners2 from "../assets/img/smartmessage.png";
import Partners3 from  "../assets/img/exotel.jpg";
import Partners4 from "../assets/img/cloudoffix.png";
import Partners5 from "../assets/img/uconnect.png";
import Partners6 from "../assets/img/touchforce.png";



import "../assets/css/OurPartners.css";

const partners = [
  {
    image: Partners1,
    className: "partners1",
  },
  {
    image: Partners2,
    className: "partners2",
  },
  {
    image: Partners3,
    className: "partners3",
  },
  {
    image: Partners4,
    className: "partners4",
  },
  {
    image: Partners5,
    className: "partners5",
  },
  {
    image: Partners6,
    className: "partners6",
  },
];

const OurPartners = () => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: true,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
  <div className="partners-slider">
  <Slider {...settings}>
    {partners.map((partner, index) => (
      <div key={index} className="partner-slide">
        <div className="partner-card">
          <img
            src={partner.image}
            alt={`Partner ${index + 1}`}
            className={partner.className}
          />
        </div>
      </div>
    ))}
  </Slider>
</div>
  );
};

export default OurPartners;